import { SxProps } from '@mui/material';

export const sxTranscricaoListaTable: SxProps = {
  borderRadius: '16px',
  width: '100%',
  boxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 0.08)',
};

export const sxTranscricaoListaCardDetalhesButton: SxProps = {
  borderRadius: '80px',
  padding: '12px 32px',
  width: '100%',
  minWidth: 'min-content',
  justifyContent: 'center',
  gap: '8px',
  border: '2px solid #00995d',
  color: '#00995d',
  backgroundColor: '#fff',
  textTransform: 'none',
  boxSizing: 'border-box',
  '&:hover': {
    backgroundColor: 'rgba(0, 153, 93, 0.06)',
    border: '2px solid #00995d',
  },
  '& .MuiButton-startIcon': {
    marginRight: '8px',
    marginLeft: 0,
  },
  '& b': {
    color: '#00995d',
    fontFamily: 'UnimedSans-Bold, Unimed-Sans, sans-serif',
    fontSize: '14px',
    fontWeight: 700,
    letterSpacing: '0.02em',
  },
};
